import React, { useMemo } from "react";
import moment from "moment";
import DOMPurify from 'dompurify';
import { replacePlaceholders } from "../../helpers/replacePlaceholders";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { useUserContext } from "../../context/UserContext";

export default ({ block }) => {
    const { getProperty } = useLocaleContext();
    const { event } = useEventContext();
    const { user } = useUserContext();

    const eventName = getProperty(event, "name");
    const userName = user?.info?.name;
    const userEmail = user?.email;
    const [dateStart, timeStart] = moment.unix(event.timeStart).format('LLL').split(', ');
    const [dateStop, timeStop] = moment.unix(event.timeStop).format('LLL').split(', ');

    const placeholders = {
        eventName,
        dateStart,
        timeStart,
        dateStop,
        timeStop,
        userName,
        userEmail
    };

    const style = {
        backgroundColor: "#" + (block.backgroundColor || block.properties?.backgroundColor),
        backgroundImage: block.imageUrl ? `url(${block.imageUrl})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }

    const text = replacePlaceholders(getProperty(block, "text"), placeholders);

    const elementText = useMemo(() => {
        if (!text) {
            return '';
        }

        return DOMPurify.sanitize(text, {
            ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'src'],
        });
    }, [text]);

    return (
        <section className={"page-block"} style={style}>
            {elementText ? (
                <div dangerouslySetInnerHTML={{__html: elementText}} className="scrollable" />
            ) : (block.textLines || []).map((line, index) => (
                <p
                    key={index}
                    style={{ color: "#" + line.textColor, fontSize: line.fontSize, margin: '0.25em 0', whiteSpace: "pre-wrap" }}
                >
                    {replacePlaceholders(getProperty(line, "text"), placeholders)}
                </p>
            ))}
        </section>
    );
}
